import { computed, type ComputedRef } from 'vue';
import { useShadesStore } from '../stores/shades';
import { SUN_SEASON_LABELS, sunLabel } from '../utils/sunTracker';

/**
 * Season id → display name, for the sun controller's cell labels and
 * validation sentences. The Shades category's custom seasons win; the legacy
 * seeded ids keep their labels as the fallback.
 */
export function useShadeSeasonLabels(): ComputedRef<Record<string, string>> {
  const shades = useShadesStore();
  return computed(() => {
    const labels: Record<string, string> = {
      summer: sunLabel(SUN_SEASON_LABELS.summer),
      winter: sunLabel(SUN_SEASON_LABELS.winter),
    };
    for (const season of shades.seasonsSorted) {
      labels[season.id] = season.name;
    }
    return labels;
  });
}
